import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import { IonicPage, NavParams } from 'ionic-angular';
import { VariablesProvider } from '../../providers/variables/variables';
import { PicajesPage } from '../../pages/picajes/picajes';
import { ViewController } from 'ionic-angular';
import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
//import { FuncionesProvider } from '../../providers/funciones/funciones';

@IonicPage()
@Component({
  selector: 'page-verlista',
  templateUrl: 'verlista.html',
})
export class VerlistaPage {

  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  myForm2: FormGroup;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {codigo1: "",nombre1: "",empresa1: "",obra1: "",turno1: "",horas1: "",activo1: ""}
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  trabajadores;
  empresas;
  obras;
  puestos;
  turnos;
  valo="654321123456" ;
  formulario2 = {valor: ""}
  trabajadoresKeys;
  values:Array<string> = [];
  rs_xls;
  muestragif;
  id;
  posicion: number = 0;
  pos: number = 0 ;
  itemData: any = [];
  items = [];
  grupoid;
  caption: string;
  lbl1: string;
  rsx;
  tabla;
   
  constructor(
    public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public variables:VariablesProvider,    
    public params: NavParams,
    public viewCtrl: ViewController
   // public funciones:FuncionesProvider
  ) {
    
    this.myForm = this.fb.group({id: [''], nombre: ['' ], activo: ['' ] });
    this.id = params.get('id'); 
    this.caption = params.get('caption');
    this.grupoid = params.get('idgrupo');
    this.tabla = params.get('tabla');
    this.rsx = [];

    if (this.tabla=="objetoslin") {

      this.variables.selgrupos(this.id).then(
            data => {
              this.rsx = data;
            }
        )
        .catch(
          error => {
            console.log(error);
          }
        )    
    }



  }

seleccionar(codigo){

    if (this.tabla=="objetoslin") {

      this.resultado=[];
       this.variables.grabarobjetoslin(this.id,codigo).then(
         data => {
              this.resultado = data;
              
              //console.log("Empieza......tabla=objetoslin...................");

              this.rsx = [];
              
              this.variables.selgrupos(this.id).then(
                    data => {
                      this.rsx = data;
                    }
                )
              }
            )
      }
  }

  dismiss() {
    //console.log("Se va...");
    this.viewCtrl.dismiss(
      {
        'trabajadores': "this.puestos",
        'turnos': "this.turnos"
      }
    ); 
  }

}


// WEBPACK FOOTER //
// ./src/pages/verlista/verlista.ts